
































import JdsGlyph from "@/design-system/icons/JdsGlyph.vue";
import JdsIcon from "@/design-system/icons/JdsIcon.vue";
import { ActiveInject } from '@/support/reactive';
import anime from "animejs";
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 * @changelog 3.0.0 Add collapse button.
 * @changelog 4.5.4 Switch to clamped 150px~280px width.
 * @changelog 5.11.0-rc.1 Changes background to white
 * @changelog 6.10.0 Enable closing by force. 
 * @typed
 */
@Component({
    components: { JdsGlyph, JdsIcon }
})
export default class JdsNavigatorFullPageLayout extends Vue {
    collapsed: boolean = false;
    @ActiveInject({ from: 'jds.meridian.bus' }) meridianBus!: Vue | null

    @Watch('collapsed', { immediate: true })
    updateProviderCollapsed(state: boolean) {
        if (this.meridianBus) {
            this.meridianBus.$emit('update', state)
        }
    }

    /**
     * Forcibly close the navigator.
     * @public
     */
    close() {
        this.collapsed = true
    }

    beforeDestroy() {
        // Make sure we "collapse" the navigator before leaving
        this.updateProviderCollapsed(true)
    }

    @Ref() navigatorEl!: HTMLElement;

    enter(el: Node, done: () => void) {
        anime.timeline({
            easing: 'easeOutQuad',
            complete: done,
        }).add({
            targets: this.navigatorEl,
            translateX: [-100, 0],
            opacity: [0, 1],
            duration: 250,
            delay: 50,
        })
    }

    leave(el: Node, done: () => void) {
        anime.timeline({
            easing: 'easeInQuad',
            complete: done,
        }).add({
            targets: this.navigatorEl,
            translateX: [0, -100],
            opacity: [1, 0],
            duration: 250,
        })
    }
}
